export default function notNoIndex({ noindex }: { noindex: boolean }): boolean {
    return !noindex;
}
